import React, { useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";

import * as ACTIONS from "../../../store/actions/actions";
import CropImageView from "./CropImageView";

// import data from "./AvatarList";

const fileSizeLimit = 5242880; // 2MB

function UploadBox(props) {
  const [file, setFile] = useState(null);
  const [notImage, setNotImage] = useState(false);

  const fileInputRef = useRef(null);

  const dispatch = useDispatch();

  const upload = (f, e) => {
    if (f.size > fileSizeLimit) {
      alert(`Rozmiar zdjęcia przekracza ${fileSizeLimit/1048576} MB. Wybierz mniejszy plik.`);
      if (e) {
        e.target.value = ''; 
      }
    } else {
      setFile(URL.createObjectURL(f));
    }
  }

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;

    if (files.length) {
      const imageType = /^image\//;
      if (imageType.test(files[0].type)) {
        upload(files[0]);
      } else {
        setNotImage(true);
      }
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
  };

  const handleClick = (e) => {
      fileInputRef.current.click();
  }

  const handleFileChange = (e) => {
    const files = e.target.files;

    if (files.length) {
      upload(files[0], e);
    }
  };

  //UPLOADER
  function uploadImage(blob) {
    dispatch(ACTIONS.spinner(true))

    const formData =  new FormData();
    formData.append('image', blob);
    formData.append('fname', blob.name);
    // let url = "https://columbusenergy.pl/lp/stopka/generator/sendCropped.php";
    let url = "https://stopka.columbusenergy.pl/sendCropped.php";
    axios.post(url, formData, {
    })
    .then(res => {
      dispatch(ACTIONS.user_image(res.data.url));
      dispatch(ACTIONS.spinner(false));
    })
    .catch(err => {
      // console.log(err.toJSON());
      // alert('spróbuj ponownie');
      dispatch(ACTIONS.spinner(false));
      dispatch(ACTIONS.image_upload_error(true));
    });
  }
  //UPLOADER THE END

  return (
    <>
      {/* Open Avatar drop down - avatarBoxToggle state true*/}
      <div className={props.uploadBoxActive ? "hide" : "showAvatars"}>
        <div className="closeBtn__container">
          <button
            type="text"
            className="closeBtn"
            onClick={(e) => {
              props.overlayToggle(e);
              props.uploadBoxToggle(e);
            }}
          >
            Zamknij
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.072 4.8L8 6.872L5.928 4.8L4.8 5.928L6.872 8L4.8 10.072L5.928 11.2L8 9.128L10.072 11.2L11.2 10.072L9.128 8L11.2 5.928L10.072 4.8ZM8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z"
                fill="#787878"
              />
            </svg>
          </button>
        </div>

        {file ? (
          <CropImageView
            file={file}
            onBackArrowClick={() => { setFile(null); setNotImage(false); }}
            onSubmitClick={(e, blob) => {
              uploadImage(blob);
              props.overlayToggle(e);
              props.uploadBoxToggle(e);
            }}
          />
        ) : (
          <>
            <h4 className="activeBox-title">Wybierz zdjęcie</h4>
            <div
              className="uploadBox-placeholder"
              onClick={(e) => handleClick(e)}
              onDrop={(e) => handleDrop(e)}
              onDragOver={(e) => handleDragOver(e)}
            >
              <input
                type="file"
                hidden
                accept="image/png, image/jpeg"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
              {notImage ? (
                <p>Wybierz poprawny format pliku (.jpg, .png).</p>
              ) : (
                <p>
                  Wybierz zdjęcie z urządzenia
                  <br />
                  lub przeciągnij zdjęcie tutaj
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

// export default UploadBox;

function mapStateToProps(state) {
  return {
    user_image: state.user_reducer.user_image,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    action_creator_image: (text) => dispatch(ACTIONS.user_image(text)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadBox);
